import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ChevronDown } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { GEO_LABELS } from '../../data/geo';

// Visible FAQ + FAQPage JSON-LD (emitted only because the Q&A is rendered).
const FAQ = ({ items = [], title }) => {
  const { lang } = useLang();
  if (!items.length) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((it) => ({
      '@type': 'Question',
      name: it.q,
      acceptedAnswer: { '@type': 'Answer', text: it.a },
    })),
  };

  return (
    <section aria-label={title || GEO_LABELS[lang].faqTitle} className="scroll-mt-24">
      <Helmet><script type="application/ld+json">{JSON.stringify(jsonLd)}</script></Helmet>
      <h2 className="text-[22px] font-extrabold tracking-tight text-slate-900">{title || GEO_LABELS[lang].faqTitle}</h2>
      <div className="mt-5 divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white">
        {items.map((it, i) => (
          <details key={i} className="group px-5 py-4 open:bg-slate-50/60">
            <summary className="flex items-center justify-between gap-4 cursor-pointer list-none">
              <h3 className="text-[15px] font-bold text-slate-900">{it.q}</h3>
              <ChevronDown className="w-4 h-4 text-blue-700 shrink-0 transition-transform group-open:rotate-180" />
            </summary>
            <p className="mt-3 text-[14px] text-slate-600 leading-relaxed">{it.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
